import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip
} from "@material-ui/core";

import {
  Add,
  Edit,
  DeleteOutline
} from "@material-ui/icons";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import Title from "../../components/Title";

import ApiConnectionModal from "../../components/ApiConnectionModal";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles
  },
  token: {
    fontFamily: "monospace",
    fontSize: 12
  }
}));

const ApiConnections = () => {
  const classes = useStyles();

  const [apiConnections, setApiConnections] = useState([]);
  const [loading, setLoading] = useState(false);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedApiConnection, setSelectedApiConnection] = useState(null);

  const loadApiConnections = async () => {
    setLoading(true);

    try {
      const { data } = await api.get("/api/api-connections");

      setApiConnections(data);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadApiConnections();
  }, []);

  const handleOpenCreateModal = () => {
    setSelectedApiConnection(null);
    setModalOpen(true);
  };

  const handleOpenEditModal = apiConnection => {
    setSelectedApiConnection(apiConnection.id);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedApiConnection(null);
  };

  const handleDelete = async apiConnectionId => {
    if (!window.confirm("¿Deseas eliminar esta conexión API?")) {
      return;
    }

    try {
      await api.delete(
        `/api/api-connections/${apiConnectionId}`
      );

      toast.success("Conexión API eliminada");

      loadApiConnections();
    } catch (err) {
      toastError(err);
    }
  };

  const maskToken = token => {
    if (!token) {
      return "";
    }

    if (token.length <= 10) {
      return "********";
    }

    return `${token.substring(0, 6)}...${token.substring(
      token.length - 4
    )}`;
  };

  return (
    <MainContainer>

      {/* =====================================================
          MODAL CREAR / EDITAR CONEXIÓN API
      ===================================================== */}

      <ApiConnectionModal
        open={modalOpen}
        onClose={handleCloseModal}
        apiConnectionId={selectedApiConnection}
        onSave={loadApiConnections}
      />

      {/* =====================================================
          HEADER
      ===================================================== */}

      <MainHeader>
        <Title>Conexiones API</Title>

        <MainHeaderButtonsWrapper>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={handleOpenCreateModal}
          >
            Nueva conexión
          </Button>
        </MainHeaderButtonsWrapper>
      </MainHeader>

      {/* =====================================================
          TABLA
      ===================================================== */}

      <Paper
        className={classes.mainPaper}
        variant="outlined"
      >
        <Table size="small">

          <TableHead>
            <TableRow>

              <TableCell align="center">
                Nombre
              </TableCell>

              <TableCell align="center">
                WhatsApp
              </TableCell>

              <TableCell align="center">
                Estado
              </TableCell>

              <TableCell align="center">
                Token
              </TableCell>

              <TableCell align="center">
                Acciones
              </TableCell>

            </TableRow>
          </TableHead>

          <TableBody>

            {loading ? (

              <TableRow>
                <TableCell
                  colSpan={5}
                  align="center"
                >
                  Cargando...
                </TableCell>
              </TableRow>

            ) : apiConnections.length === 0 ? (

              <TableRow>
                <TableCell
                  colSpan={5}
                  align="center"
                >
                  No existen conexiones API.
                </TableCell>
              </TableRow>

            ) : (

              apiConnections.map(apiConnection => (

                <TableRow
                  key={apiConnection.id}
                >

                  {/* =========================
                      NOMBRE
                  ========================= */}

                  <TableCell align="center">
                    {apiConnection.name}
                  </TableCell>

                  {/* =========================
                      WHATSAPP
                  ========================= */}

                  <TableCell align="center">
                    {apiConnection.whatsapp
                      ? apiConnection.whatsapp.name
                      : "-"}
                  </TableCell>

                  {/* =========================
                      ESTADO
                  ========================= */}

                  <TableCell align="center">

                    <Chip
                      size="small"
                      label={
                        apiConnection.isActive
                          ? "Activa"
                          : "Inactiva"
                      }
                    />

                  </TableCell>

                  {/* =========================
                      TOKEN
                  ========================= */}

                  <TableCell
                    align="center"
                    className={classes.token}
                  >
                    {maskToken(
                      apiConnection.token
                    )}
                  </TableCell>

                  {/* =========================
                      ACCIONES
                  ========================= */}

                  <TableCell align="center">

                    <IconButton
                      size="small"
                      onClick={() =>
                        handleOpenEditModal(
                          apiConnection
                        )
                      }
                    >
                      <Edit />
                    </IconButton>

                    <IconButton
                      size="small"
                      onClick={() =>
                        handleDelete(
                          apiConnection.id
                        )
                      }
                    >
                      <DeleteOutline />
                    </IconButton>

                  </TableCell>

                </TableRow>

              ))

            )}

          </TableBody>

        </Table>
      </Paper>

    </MainContainer>
  );
};

export default ApiConnections;